<template>
  <v-dialog
    v-model="dialogFlag"
    persistent
    max-width="900"
  >
    <v-card>
      <v-card-title class="primary--text">
        Global Coach Group
      </v-card-title>
      <v-card-text class="pb-5">
        <template v-if="['register', 'payment'].includes(option)">
          <p>
            You are currently not registered for this service.
          </p>
          <p>
            Please email
            <a href="mailto:Support@GlobalCoachGroup.com">
              Support@GlobalCoachGroup.com
            </a> for support.
          </p>
        </template>

        <template v-else-if="option === 'tos'">
          <TermsOfService />
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TermsOfService from './widget/TermsOfService.vue';

export default {
  name: 'PaymentInformation',

  components: {
    TermsOfService,
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    // register, payment, tos
    option: {
      type: String,
      default: 'register',
    },
  },

  computed: {
    dialogFlag: {
      get() {
        return this.dialog;
      },
      set(newValue) {
        this.$emit('update:dialog', newValue);
      },
    },
  },

  methods: {
    openLink(link) {
      window.open(link, '_blank');
    },
  },
};
</script>
